import { render, staticRenderFns } from "./meal_detail.vue?vue&type=template&id=2f4e7eaa&"
import script from "./meal_detail.vue?vue&type=script&lang=js&"
export * from "./meal_detail.vue?vue&type=script&lang=js&"
import style0 from "./meal_detail.vue?vue&type=style&index=0&id=2f4e7eaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports